module.exports = __webpack_public_path__ + "img/962-487e3d.png";